import Contract from './Contract';
export default Contract;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/Contract/index.ts